import CallToAction from "components/CallToAction"
import { getStoryblokLink } from "utilities/getStoryblokLink"

const ArticleCard = ({ name, full_slug }) => {
  return (
    <div className="bg-white p-8 flex flex-col items-center justify-center">
      <h3 className="text-center pb-4 text-m2">{name}</h3>
      <div>
        <CallToAction href={full_slug} style="secondary-black">
          Read Story
        </CallToAction>
      </div>
    </div>
  )
}

export default function PressArticlesSection({ blok }) {
  return (
    <section className="bg-blueWaveOverlay bg-cover bg-no-repeat bg-left-top py-10 px-5">
      <div className="max-w-screen-xl mx-auto flex flex-col items-center">
        <h2 className="text-white text-center">{blok.heading}</h2>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-7 my-9">
          {blok.news_items?.map((item) => (
            <ArticleCard key={item.name} {...item} />
          ))}
        </div>
        <CallToAction href={getStoryblokLink(blok.cta_link)} style="ghost" className="text-white">
          {blok.cta_label}
        </CallToAction>
      </div>
    </section>
  )
}
